import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CredentialsService } from './logic/credentials.service';
import { CredentialsLogicService } from './logic/credentials/credentials-logic.service';
import { CredentialsDaoService } from './dao/credentials-dao.service';
import { CredentialsStorageDaoService } from './dao/credentials-dao/credentials-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: CredentialsService, useClass: CredentialsLogicService },
    { provide: CredentialsDaoService, useClass: CredentialsStorageDaoService }
  ]
})
export class CredentialsModule {}
